export const UPDATE_LOGED_USER = 'UPDATE_LOGED_USER';